import { Routes, Route } from 'react-router-dom';
import { RequisitionsListPage } from './requisitions-list-page';
import { RequisitionFormPage } from './requisition-form-page';
import { RequisitionDetailPage } from './requisition-detail-page';

export function RequisitionsPage() {
  return (
    <Routes>
      <Route index element={<RequisitionsListPage />} />
      <Route path="new" element={<RequisitionFormPage />} />
      <Route path=":id" element={<RequisitionDetailPage />} />
      <Route path=":id/edit" element={<RequisitionFormPage />} />
    </Routes>
  );
}
